import React, { useRef, useState } from 'react';
// @ts-ignore
import styles from './CalendarTermPicker.module.scss';
import Modal from '../Modal/Modal';
import { useAppContext } from '../../Services/AppContext';
// @ts-ignore
import moment, { Moment } from 'moment';
import CalendarPatientEvent from './CalendarPatientEvent';
import CalendarWorkplaceScheduleEvent from './CalendarWorkplaceScheduleEvent';

interface ICalendarWorkplaceScheduleEventModal {
	opened: boolean;
	onClose: any;
	selectedDate: Moment;
	defaultData?: any;
	workplaceId?: string;
	onSuccess: () => void;
	onDelete: () => void;
}

export default function CalendarWorkplaceScheduleEventModal(
	props: ICalendarWorkplaceScheduleEventModal,
) {
	const {
		opened,
		onClose,
		onSuccess,
		selectedDate,
		defaultData,
		workplaceId,
		onDelete,
	} = props;
	const [data, setData] = useState(defaultData);

	return (
		<div className={styles.wrapper}>
			<Modal opened={opened} onClose={onClose}>
				<Modal.Header
					title={
						defaultData
							? 'base.editShiftsSchedule'
							: 'base.createShiftsSchedule'
					}
					firstUpper
				/>
				<Modal.Content>
					<CalendarWorkplaceScheduleEvent
						schedule={defaultData}
						selectedDate={selectedDate}
						onSuccess={onSuccess}
						workplaceId={workplaceId}
						onDelete={onDelete}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
